"use strict";

exports.__esModule = true;
exports.AlertTicketTag = AlertTicketTag;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var TagWrapper = (0, _styledComponents["default"])(_core.Tag).withConfig({
  displayName: "AlertTicketTag__TagWrapper",
  componentId: "sc-1ka22vt-0"
})(["margin:0 0.3rem 0.3rem 0;"]);
function AlertTicketTag(props) {
  var content = props.content,
    getValue = props.getValue,
    getKey = props.getKey,
    getColor = props.getColor,
    getBackgroundColor = props.getBackgroundColor,
    _props$style = props.style,
    style = _props$style === void 0 ? {} : _props$style;
  var tagStyle = Object.assign({}, style); // style is not extensible
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, content.map(function (tag) {
    if (getColor) {
      tagStyle.color = getColor(tag);
    }
    if (getBackgroundColor) {
      tagStyle.backgroundColor = getBackgroundColor(tag);
    }
    return /*#__PURE__*/_react["default"].createElement(TagWrapper, {
      key: getKey(tag),
      style: tagStyle
    }, getValue(tag));
  }));
}